import React from "react";
import { useIsVisible } from "../hooks/useIsVisible";

const Header = ({ mapRef, chartsRef, historyRef, searchRef, chartWatchRef }) => {
  const isMapVisable = useIsVisible(mapRef);
  const isHistoryVisable = useIsVisible(historyRef);
  const isChartVisable = useIsVisible(chartWatchRef);
  const isSearchVisable = useIsVisible(searchRef);

  return (
    <header className="bg-[#373737] flex justify-between sticky top-0 z-[99999] h-[6vh]">
      <div className="flex gap-2 mr-2">
        <div
          onClick={() => searchRef?.current?.scrollIntoView({ behavior: "smooth" })}
          style={{ background: isSearchVisable ? "red" : "#161616" }}
          className=" cursor-pointer bg-red-600 h-fit my-auto text-white py-1 px-4 text-xl rounded-2xl"
        >
          <i className="fas fa-search"></i>
        </div>
        <div
          onClick={() => chartsRef?.current?.scrollIntoView({ behavior: "smooth" })}
          style={{ background: isChartVisable ? "red" : "#161616" }}
          className="cursor-pointer bg-red-600 h-fit my-auto text-white py-1 px-4 text-xl rounded-2xl"
        >
          גרפים
        </div>
        <div
          onClick={() => mapRef?.current?.scrollIntoView({ behavior: "smooth" })}
          style={{ background: isMapVisable ? "red" : "#161616" }}
          className="cursor-pointer h-fit my-auto text-white py-1 px-4 text-xl rounded-2xl"
        >
          מפה
        </div>
        <div
          onClick={() => historyRef?.current?.scrollIntoView({ behavior: "smooth" })}
          style={{ background: isHistoryVisable ? "red" : "#161616" }}
          className="cursor-pointer bg-[#161616] h-fit my-auto text-white py-1 px-4 text-xl rounded-2xl"
        >
          היסטוריה
        </div>
      </div>
      <div className="flex p-2">
        <div>
          <h1 className="text-5xl text-[4vh] font-semibold text-white ml-2 hidden md:block mt-[1px]">צופר - ניתוח התרעות</h1>
        </div>
        <div>
          <a href="https://www.tzevaadom.co.il/systems/" alt="systems">
            <img src="https://www.tzevaadom.co.il/static/images/icon.png" alt="" className="mr-auto w-auto h-full"></img>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
